import * as Mui from "@material-ui/core";
import { useTranslation } from "react-i18next";
import { useWidth } from "../../hooks/common/useWidth";
import { useState } from "react";

export const WarningPopover = ({ onClose, onContinue, popoverAnchor, popoverOpen, title, description }) => {
    const { t } = useTranslation()
    const width = useWidth()
    return (
        <Mui.Popover
            id={`reconcile-popover`}
            classes={{ root: "kebab-dropdown" }}
            anchorEl={popoverAnchor}
            anchorOrigin={{
                vertical: "bottom",
                horizontal: "left",
            }}
            transformOrigin={{
                vertical: "top",
                horizontal: "left",
            }}
            open={popoverOpen}
            onClose={onClose}
        >
            <Mui.Box className="p-3">
                <Mui.Typography
                    component="h5"
                    variant="h5"
                    className="font-weight-medium text-color-black"
                >
                    {title ?? t('CANTEEN.CHANGES_DETECTED')}
                </Mui.Typography>
                <Mui.Typography className="mt-1">
                    {description ?? t('CANTEEN.CHANGES_DETECTED_DESC')}
                </Mui.Typography>

                <Mui.Box
                    width="100%"
                    display="flex"
                    justifyContent={'flex-end'}
                    alignItems={'flex-end'}
                    className="mt-3"
                    gridGap={10}
                >
                    <Mui.Button
                        className={`btn-default no-color-btn ${Mui.isWidthDown("xs", width) ? "mb-3" : "mr-3"
                            }`}
                        color="primary"
                        type="button"
                        variant="outlined"
                        disableElevation
                        onClick={(e) => {
                            e?.preventDefault();
                            if (document.activeElement instanceof HTMLElement) {
                                document.activeElement.blur();
                            }
                            onClose?.()
                        }}
                    >
                        {t("COMMON.BUTTON.CANCEL")}
                    </Mui.Button>
                    <Mui.Button
                        className={`btn-default ${Mui.isWidthDown("xs", width) ? "mb-3" : "mr-3"
                            }`}
                        color="primary"
                        variant="contained"
                        disableElevation
                        onClick={onContinue}
                    >
                        {t("COMMON.BUTTON.CONTINUE")}
                    </Mui.Button>
                </Mui.Box>
            </Mui.Box>
        </Mui.Popover>
    )
}

export const ConfirmationPopover = ({ component, title, description, onConfirm, popOn = true }) => {

    const [popoverAnchor, setPopoverAnchor] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const { t } = useTranslation();

    const handleContinue = (e) => {
        e?.preventDefault();
        setPopoverOpen(false);
        onConfirm();
    };

    const handleClose = (e) => {
        e?.preventDefault();
        setPopoverAnchor(e.currentTarget)
        setPopoverOpen(true);

    };

    return <>
        {component ? component?.(popOn ? handleClose : onConfirm) : <></>}
        <WarningPopover
            onClose={() => {
                setPopoverOpen(false);
            }}
            onContinue={handleContinue}
            popoverAnchor={popoverAnchor}
            popoverOpen={popoverOpen}
            title={title ?? t("CANTEEN.CHANGES_DETECTED")}
            description={description ?? t("CANTEEN.CHANGES_DETECTED_DESC")}
        />
    </>
}